// extracted by mini-css-extract-plugin
module.exports = {"block":"_7191","hd":"_1729","title":"_11213","arrow":"_14446","empty":"_2316","bd":"_5865","ft":"_7583"};